"use strict";
// =============================================================
// Minimal backend imports for the social media gate bundle.
// Only imports what the social-media-gate page and its sub-components need.
// =============================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACL = exports.backendRoutes = void 0;
// ── Specific backend routing files (NOT global routes.ts) ─────
const authActions_1 = require("@back/config/routing/authActions");
const settingsActions_1 = require("@back/config/routing/settingsActions");
const aiActions_1 = require("@back/config/routing/aiActions");
const socialMediaPostActions_1 = require("@back/config/routing/socialMediaPostActions");
const socialMediaPlanActions_1 = require("@back/config/routing/socialMediaPlanActions");
const userActions_1 = require("@back/config/routing/userActions");
// ── ACL (required by routes.ts which is imported by gate.ts) ──
const resources_1 = require("@back/app/acl_module/config/resources");
const actions_1 = require("@back/app/acl_module/config/actions");
const acl_helpers_1 = require("@back/app/acl_module/acl.helpers");
const ACL = {
    aclResources: resources_1.aclResources,
    aclActions: actions_1.aclActions,
    checkACL: acl_helpers_1.checkACL,
};
exports.ACL = ACL;
// ── Minimal backend routes (gate-only) ────────────────────────
exports.backendRoutes = [
    { prefix: '/api/auth', controllerName: 'auth', routes: authActions_1.authRoutes },
    { prefix: '/api/user', controllerName: 'user', routes: userActions_1.userRoutes },
    { prefix: '/api/settings', controllerName: 'settings', routes: settingsActions_1.settingsRoutes },
    { prefix: '/api/ai', controllerName: 'ai', routes: aiActions_1.aiRoutes },
    { prefix: '/api/social-media-post', controllerName: 'social-media-post', routes: socialMediaPostActions_1.socialMediaPostRoutes },
    { prefix: '/api/social-media-plan', controllerName: 'social-media-plan', routes: socialMediaPlanActions_1.socialMediaPlanRoutes },
];
